import {useEffect, useState} from 'react';
import {Modal, Button, Form, Input,  Popconfirm, message} from 'antd';
import {useApi} from "../provider/ApiProvider";
import CompanySelector from "../components/CompanySelector";
import PlatformSelector from "../components/PlatformSelector";

const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 16 },
};

const {TextArea} = Input;

export default function CustomerDialog({open, data, onChange, onClose}){

    const {api} = useApi();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        form.setFieldsValue(data);
    },[data])

    const handleOk = () => {

    };

    const handleCancel = () => {
        onClose()
    };

    const onFinish = (values) => {
        if(data === null){
            setLoading(true);
            api.post("/customerRouter/customer/store",values).then(resp => {
                onClose();
                onChange();
                setLoading(false);
            }).finally(() => {
                setLoading(false);
            })
        }else{
            setLoading(true);
            api.put("/customerRouter/customer/update/" + data.id,values).then(resp => {
                onClose();
                onChange();
                setLoading(false);
            }).finally(() => {
                setLoading(false);
            })
        }

    };

    const onFinishFailed = (errorInfo) => {

    }

    const onDelete = (record) => {


    }



    return (
        <Modal
            title={(data === null || data === undefined) ? "Müşteri Ekle" : "Düzenle"}
            visible={open} okType={"submit"}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button  key="back" onClick={handleCancel}>
                    İptal
                </Button>,


                <Button  form="company-dialog-form" htmlType="submit" key="submit" type="primary" loading={loading} onClick={handleOk}>
                    Kaydet
                </Button>,
            ]}
        >
            <Form
                form={form}
                id="company-dialog-form"
                onFinish={onFinish}
                onFinishFailed={() => onFinishFailed("İstenen bilgileri giriniz")}
                initialValues={data}
            >
                <Form.Item
                    label="Adı"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: 'Bu alanı doldurunuz',
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="Platform"
                    name="PlatformId"
                    rules={[
                        {
                            required: true,
                            message: 'Platform seçiniz',
                        },
                    ]}
                >
                    <PlatformSelector
                        value={form.getFieldValue('PlatformId')}
                        onChange={(value) =>form.setFieldsValue({ PlatformId: value })}
                    />
                </Form.Item>


            </Form>
        </Modal>

    )
}
